import { AxiosInstance } from "axios";

interface PasswordCreateRequestBody {
  password: string;
  confirm_password: string;
}

export class PasswordCreateRequest {
  private protectedAxiosInstance: AxiosInstance;
  private path = "account/password/create";

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  async send(passwordCreateBody: PasswordCreateRequestBody): Promise<any> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.path,
        passwordCreateBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
